import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { clearLockout, selectUserLoginAttempts } from '@/state/reducers/authSlice';
import { useEffect, useState } from 'react';

function useLockoutCountdown(username: string) {
    const dispatch = useAppDispatch();
    const userLoginAttempts = useAppSelector(selectUserLoginAttempts);
    const [countdown, setCountdown] = useState('');

    useEffect(() => {
        const userState = userLoginAttempts[username];
        if (!userState?.lockoutUntil) {
            setCountdown('');
            return;
        }

        const updateCountdown = () => {
            if (!userState?.lockoutUntil) {
                dispatch(clearLockout({ username }));
                setCountdown('');
                return;
            }

            const remainingMs = userState?.lockoutUntil - Date.now();
            if (remainingMs <= 0) {
                setCountdown('');
                dispatch(clearLockout({ username }));
                return;
            }

            const minutes = Math.floor(remainingMs / 60000);
            const seconds = Math.ceil((remainingMs % 60000) / 1000);
            setCountdown(`${minutes}:${seconds.toString().padStart(2, '0')}`);
        };

        updateCountdown(); // initial calculation
        const interval = setInterval(updateCountdown, 1000); // update every second

        return () => clearInterval(interval);
    }, [userLoginAttempts, username]);

    return countdown;
}

export default useLockoutCountdown;
